// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k3Jz","placeholdersHeader":"styles_placeholdersHeader__AKN8y","editorStyle":"styles_editorStyle__b0ufV","placeholdersBox":"styles_placeholdersBox__3qpdd"};